import { TextInput as PlatformTextInput, FCX } from "@datassential/platform-ui-lib";
import { ComponentProps, ReactNode, useMemo } from "react";
import cn from "classnames";
import Field from "@components/Field";

type Modifier = 'transparent';

interface TextInputProps extends Omit<ComponentProps<typeof PlatformTextInput>, 'modifiers'> {
    prefix?: ReactNode;
    suffix?: ReactNode;
    tooltipId?: string;
    modifiers?: Modifier[];
}

const TextInput: FCX<TextInputProps> = ({
    prefix,
    suffix,
    modifiers = [],
    className,
    testId,
    tooltipId,
    ...platformProps
}) => {
    const fieldModifiers = useMemo(
        (): ComponentProps<typeof Field>['modifiers'] => platformProps.value !== '' ? ['active'] : [],
        [platformProps.value]
    );
    return (
        <Field
            className={
                cn(
                    "TextInput",
                    className,
                    modifiers?.map(modifier => `is-${modifier}`),
                )
            }
            modifiers={fieldModifiers}
            data-testid={testId}
            data-tooltip-id={tooltipId}
        >
            <div className="TextInput__inner">
                {prefix && (
                    <div
                        className="TextInput__prefix"
                        data-testid="blockTextInputPrefix"
                    >
                        {prefix}
                    </div>
                )}
                <PlatformTextInput
                    className="TextInput__input"
                    testId="inputTextInput"
                    {...platformProps}
                />
                {suffix && (
                    <div
                        className="TextInput__suffix"
                        data-testid="blockTextInputSuffix"
                    >
                        {suffix}
                    </div>
                )}
            </div>
        </Field>
    );
};

TextInput.displayName = 'TextInput';

export type TextInputComponentProps = ComponentProps<typeof TextInput>;

export default TextInput;